import React from "react";
import {
	Dialog,
	Typography,
	Divider,
	DialogContent,
	DialogTitle,
	Box,
	IconButton,
	TextField,
	InputAdornment,
	Skeleton,
	Stack
} from "@mui/material";
import { WhatsApp, FacebookRounded, X, FileCopy, Email, Close, QrCode, Share } from "@mui/icons-material";
import { ShareItem, StyledFacebookMessenger } from "./styles";

const ShareUi = ({
	open,
	shareUrl,
	onClose,
	handleShareToWhatsApp,
	handleFacebookShare,
	handleFaceBookMessengerShare,
	handleTwitterShare,
	handleCopyToClipboard,
	enableEmail,
	handleEmailShare,
	enableQRCode,
	openQRCode,
	handleDeviceShare,
	loading
}: {
	open: boolean;
	shareUrl: string;
	onClose: () => void;
	handleShareToWhatsApp: () => void;
	handleFacebookShare: () => void;
	handleFaceBookMessengerShare: () => void;
	handleTwitterShare: () => void;
	handleCopyToClipboard: () => void;
	loading: boolean;
	handleEmailShare?: () => void;
	enableEmail?: boolean;
	enableQRCode?: boolean;
	openQRCode?: () => void;
	handleDeviceShare?: () => void;
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			maxWidth={"xs"}
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">Share</DialogTitle>
			<Box display="flex" justifyContent="flex-end" style={{ position: "absolute", right: "20px", top: "20px" }}>
				<IconButton onClick={onClose}>
					<Close />
				</IconButton>
			</Box>
			<DialogContent>
				{loading ? (
					<Stack spacing={2}>
						<Stack spacing={2} width={"100%"} direction={"row"} justifyContent={"center"}>
							<Skeleton variant={"circular"} height={"45px"} width={"45px"} />
							<Skeleton variant={"circular"} height={"45px"} width={"45px"} />
							<Skeleton variant={"circular"} height={"45px"} width={"45px"} />
							<Skeleton variant={"circular"} height={"45px"} width={"45px"} />
							<Skeleton variant={"circular"} height={"45px"} width={"45px"} />
							<Skeleton variant={"circular"} height={"45px"} width={"45px"} />
						</Stack>
						<Box my={4}>
							<Divider textAlign={"center"}>
								<Typography color={"textPrimary"}>Or</Typography>
							</Divider>
						</Box>
						<Skeleton variant={"rectangular"} height={"40px"} />
					</Stack>
				) : (
					<Box display={"flex"} flexDirection={"column"}>
						<Box display={"flex"} justifyContent={"center"} alignItems={"center"} gap={1} flexWrap={"wrap"}>
							<ShareItem>
								<IconButton onClick={handleShareToWhatsApp}>
									<WhatsApp fontSize={"large"} />
								</IconButton>
							</ShareItem>
							<ShareItem onClick={handleFacebookShare}>
								<IconButton>
									<FacebookRounded fontSize={"large"} />
								</IconButton>
							</ShareItem>
							<ShareItem onClick={handleFaceBookMessengerShare}>
								<IconButton>
									<StyledFacebookMessenger />
								</IconButton>
							</ShareItem>
							<ShareItem onClick={handleTwitterShare}>
								<IconButton>
									<X fontSize={"large"} />
								</IconButton>
							</ShareItem>{" "}
							{enableEmail && handleEmailShare && (
								<ShareItem onClick={handleEmailShare}>
									<IconButton>
										<Email fontSize={"large"} />
									</IconButton>
								</ShareItem>
							)}
							{enableQRCode && openQRCode && (
								<ShareItem onClick={openQRCode}>
									<IconButton>
										<QrCode fontSize={"large"} />
									</IconButton>
								</ShareItem>
							)}
							<ShareItem onClick={handleDeviceShare}>
								<IconButton>
									<Share fontSize={"large"} />
								</IconButton>
							</ShareItem>
						</Box>
						<Box my={4}>
							<Divider textAlign={"center"}>
								<Typography color={"textPrimary"}>Or</Typography>
							</Divider>
						</Box>

						<Box>
							<TextField
								fullWidth
								type={"text"}
								value={shareUrl}
								name={"Share url"}
								slotProps={{
									input: {
										readOnly: true,
										endAdornment: (
											<InputAdornment position="end">
												<IconButton aria-label={"Share link"} onClick={handleCopyToClipboard} edge="end">
													<FileCopy />
												</IconButton>
											</InputAdornment>
										)
									}
								}}
							/>
						</Box>
					</Box>
				)}
			</DialogContent>
		</Dialog>
	);
};

export default ShareUi;
